
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 1a1 1 0 011-1h14a1 1 0 110 2v8a2 2 0 01-2 2H9v4h1a1 1 0 110 2H6a1 1 0 110-2h1v-4H3a2 2 0 01-2-2V2a1 1 0 01-1-1zm13 1H3v8h10V2z","fill":"#313131"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.763 4.2c.292.29.318.789.058 1.114l-1.5 1.876c-.57.715-1.537.823-2.224.249L6.863 6.407a.218.218 0 00-.299.014L5.18 7.799a.658.658 0 01-1-.063.854.854 0 01.057-1.114l1.385-1.379c.587-.584 1.462-.626 2.091-.1l1.235 1.033a.219.219 0 00.318-.036l1.498-1.876a.658.658 0 011-.064z","fill":"#313131"}})])
          )
        }
      }
    